import {
  type IChargePreference,
  type IUserPreferences,
} from "./default-settings.state";

export class SetUserPreferences {
  static readonly type = "[DefaultSettings] Set User Preferences";
  constructor(public userPreferences: IUserPreferences) {}
}

export class SetChargePreference {
  static readonly type = "[DefaultSettings] Set Charge Preference";
  constructor(
    public key: keyof IUserPreferences,
    public preference: IChargePreference
  ) {}
}

export class ClearDefaultSettings {
  static readonly type = "[DefaultSettings] Clear Default Settings";
}
